<template>

<v-container>

</v-container>
</template>

<script>
//import firebase from '@firebase/app';
//import 'firebase/auth';
export default {
  data: () => ({

  }),
  mounted() {
    //console.log(firebase.auth().currentUser);
  }
}
</script>
